﻿import React from "react";
import PropTypes from "prop-types";
import DomPortal from "./domPortal";

export default class SlideInSelection extends React.Component {
  static get zIndexShow() {
    return 1100;
  }
  static get zIndexHide() {
    return 0;
  }
  constructor(props) {
    super(props);

    this.state = {
      isOpened: false,
      sisBackgroundVisible: false,
      portalElementSelector: null,
      portalElement: null,
      containerId: null,
      containerElement: null,
      openClass: "out",
    };

    this.animateSetTimeout = null;
    this.backgroundVisbilitySetTimeout = null;
    this.closeCallbackSetTimeout = null;

    this.slideItIn = this.slideItIn.bind(this);
    this.slideItOut = this.slideItOut.bind(this);
    this.onFooterButtonClick = this.onFooterButtonClick.bind(this);
    this.getScrollBarWidth = this.getScrollBarWidth.bind(this);
    this.appendRemoveContainerWidth =
      this.appendRemoveContainerWidth.bind(this);
  }

  slideItIn() {
    this.appendRemoveContainerWidth(true);

    if (typeof this.props.onOpen === "function") {
      this.props.onOpen();
    }

    this.setState({ isOpened: true, sisBackgroundVisible: true }, () => {
      if (this.animateSetTimeout) {
        clearTimeout(this.animateSetTimeout);
        this.animateSetTimeout = null;
      }
      this.animateSetTimeout = setTimeout(() => {
        const primaryButton = document.getElementById("primary-back-btn");
        const secondaryButton = document.getElementById("secondary-back-btn");

        if (this.props.isSecondary) {
          if (primaryButton) {
            primaryButton.style.zIndex = SlideInSelection.zIndexHide;
            primaryButton.style.visibility = "hidden";
          }

          if (secondaryButton) {
            secondaryButton.style.zIndex = SlideInSelection.zIndexShow;
          }
        } else if (primaryButton) {
          primaryButton.style.zIndex = SlideInSelection.zIndexShow;
        }

        this.setState({
          openClass: "in",
        });
      });
    });
  }

  slideItOut(forceClose = false) {
    if (
      this.props.onFirstSlideout ||
      forceClose ||
      !this.props.isSecondary ||
      this.props.onInsufficientAuthAddressSelect
    ) {
      const primaryButton = document.getElementById("primary-back-btn");
      const secondaryButton = document.getElementById("secondary-back-btn");

      if (this.props.isSecondary && primaryButton) {
        primaryButton.style.visibility = "visible";
      }

      if (primaryButton) {
        primaryButton.style.zIndex = SlideInSelection.zIndexShow;
      }

      if (secondaryButton) {
        secondaryButton.style.zIndex = SlideInSelection.zIndexHide;
      }

      this.appendRemoveContainerWidth(false);
      this.setState({ isOpened: false, openClass: "out" }, () => {
        if (this.backgroundVisbilitySetTimeout) {
          clearTimeout(this.backgroundVisbilitySetTimeout);
          this.backgroundVisbilitySetTimeout = null;
        }
        this.backgroundVisbilitySetTimeout = setTimeout(() => {
          if (typeof this.props.closeCallback === "function") {
            this.props.closeCallback();
          }

          this.setState({
            sisBackgroundVisible: this.state.isOpened,
            openClass: this.state.isOpened ? "in" : "out",
          });
        }, 200);
      });
    } else {
      if (this.closeCallbackSetTimeout) {
        clearTimeout(this.closeCallbackSetTimeout);
        this.closeCallbackSetTimeout = null;
      }
      this.closeCallbackSetTimeout = setTimeout(() => {
        if (this.props.closeCallback) {
          const primaryButton = document.getElementById("primary-back-btn");
          const secondaryButton = document.getElementById("secondary-back-btn");

          if (this.props.isSecondary) {
            if (primaryButton) {
              primaryButton.style.zIndex = SlideInSelection.zIndexHide;
            }

            if (secondaryButton) {
              secondaryButton.style.zIndex = SlideInSelection.zIndexShow;
            }
          }

          this.props.closeCallback();
        }
      }, 100);
    }
  }

  appendRemoveContainerWidth(isOpen) {
    if (!this.props.isSecondarySlideIn) {
      if (typeof this.props.appendRemoveContainerWidth === "function") {
        this.props.appendRemoveContainerWidth(isOpen);
      } else {
        if (isOpen) {
          document.body.classList.add("modal-open");
        } else if (document.getElementsByClassName("modal show").length <= 0) {
          //leave class if slide-in was opened within a modal
          document.body.classList.remove("modal-open");
        }
        if (this.state.containerElement) {
          if (isOpen) {
            let scrollbarWidth = this.getScrollBarWidth();
            this.state.containerElement.style.width =
              "calc(100% - " + scrollbarWidth + "px)";
          } else {
            this.state.containerElement.style.width = null;
          }
        }
      }
    }
  }

  onFooterButtonClick(e) {
    this.slideItOut();
    this.props.onFooterButtonClick(e);
  }

  renderDoneButtonFooter() {
    return (
      <div className="select-done">
        <button
          type="button"
          className="btn btn-primary"
          onClick={this.onFooterButtonClick}
        >
          {this.props.footerButtonText}
        </button>
      </div>
    );
  }

  componentWillUnmount() {
    if (this.animateSetTimeout) {
      clearTimeout(this.animateSetTimeout);
    }

    if (this.backgroundVisbilitySetTimeout) {
      clearTimeout(this.backgroundVisbilitySetTimeout);
    }

    if (this.closeCallbackSetTimeout) {
      clearTimeout(this.closeCallbackSetTimeout);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.forceOpen !== this.props.forceOpen &&
      this.props.forceOpen == true
    ) {
      this.slideItIn();
    }
  }

  static getDerivedStateFromProps(props, state) {
    let stateChange = {};

    if (props.slideInDom && props.slideInDom !== state.portalElementSelector) {
      stateChange.portalElementSelector = props.slideInDom;
      stateChange.portalElement = document.getElementById(
        stateChange.portalElementSelector
      );
    }

    if (props.containerId && props.containerId !== state.containerId) {
      stateChange.containerId = props.containerId;
      stateChange.containerElement = document.getElementById(
        stateChange.containerId
      );
    }

    return Object.keys(stateChange).length !== 0 ? stateChange : null;
  }

  getScrollBarWidth() {
    if (
      document.body.parentElement.scrollHeight <=
      document.body.parentElement.clientHeight
    ) {
      return 0;
    }

    var scrollDiv = document.createElement("div"); // .modal-scrollbar-measure styles // https://github.com/twbs/bootstrap/blob/v4.0.0-alpha.4/scss/_modal.scss#L106-L113

    scrollDiv.style.position = "absolute";
    scrollDiv.style.top = "-9999px";
    scrollDiv.style.width = "50px";
    scrollDiv.style.height = "50px";
    scrollDiv.style.overflow = "scroll";

    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);

    return scrollbarWidth;
  }

  renderSlideInContent() {
    return (
      <>
        <div
          className={"main-slide-in-box slide-" + this.state.openClass}
          style={{ backgroundColor: `${this.props.backgroundColor}` }}
        >
          <div className="sis-header">
            <div
              id={
                this.props.isSecondary
                  ? "secondary-back-btn"
                  : "primary-back-btn"
              }
              className={
                "sis-back-btn" + (this.props.isSecondary ? " is-secondary" : "")
              }
              onClick={() => this.slideItOut()}
              style={{ display: this.props.onSearchAddress ? "none" : "block" }}
            />

            <div className="sis-header-custom-content font-weight-bold">
              {this.state.sisBackgroundVisible && this.props.header}
            </div>
          </div>
          <div className="sis-body" onScroll={this.props.onScrollBody}>
            {this.props.title ||
              (this.props.titleLinkText && this.props.titleLinkOnClick) ? (
              <>
                <div className="container">
                  <div className="row select-header">
                    <div className="col text-left">
                      <span className="font-weight-bold">
                        {this.props.title}
                      </span>
                    </div>
                    {this.props.titleLinkText && this.props.titleLinkOnClick && (
                      <div className="col text-right">
                        <button
                          className="btn btn-link"
                          onClick={this.props.titleLinkOnClick}
                        >
                          {this.props.titleLinkText}
                        </button>
                      </div>
                    )}
                  </div>
                  {this.props.children}
                  {this.props.onFooterButtonClick &&
                    this.renderDoneButtonFooter()}
                </div>
              </>
            ) : (
              <>
                {this.props.children}
                {this.props.onFooterButtonClick &&
                  this.renderDoneButtonFooter()}
              </>
            )}
          </div>
        </div>
        {!this.props.isSecondarySlideIn && (
          <div
            className={`sis-background ${this.state.isOpened ? "open" : ""} ${this.state.sisBackgroundVisible ? "visible" : ""
              }`}
            onClick={
              this.state.isOpened
                ? () => {
                  this.slideItOut(true);
                }
                : undefined
            }
          />
        )}
      </>
    );
  }

  render() {
    return (
      <>
        <div className="sis-wrapper">
          <div className="sis-button" onClick={() => this.slideItIn()}>
            {this.props.button}
          </div>
          {this.state.sisBackgroundVisible && (
            <DomPortal slideInDom={this.state.portalElement}>
              {this.renderSlideInContent()}
            </DomPortal>
          )}
        </div>
      </>
    );
  }
}

SlideInSelection.propTypes = {
  button: PropTypes.element,
  onOpen: PropTypes.func,
  closeCallback: PropTypes.func,
  containerId: PropTypes.string,
  footerButtonText: PropTypes.string,
  onFirstSlideout: PropTypes.bool,
  onFooterButtonClick: PropTypes.func,
  onSearchAddress: PropTypes.bool,
  slideInDom: PropTypes.string,
  title: PropTypes.string,
  titleLinkText: PropTypes.string,
  titleLinkOnclick: PropTypes.string,
  isSecondary: PropTypes.bool,
  isSecondarySlideIn: PropTypes.bool,
  appendRemoveContainerWidth: PropTypes.func,
  onScrollBody: PropTypes.func,
  forceOpen: PropTypes.bool,
};

SlideInSelection.defaultProps = {
  footerButtonText: "DONE",
  isSecondary: false,
  isSecondarySlideIn: false,
  onFirstSlideout: false,
  onSearchAddress: false,
  backgroundColor: "",
};
